import styled from 'styled-components';
import { FormTextarea } from '@spotify-internal/encore-web';
import { useTranslation } from 'react-i18next';
import React, { useCallback, useState } from 'react';
import { AddAttachmentButton } from './AddAttachmentButton';
import { SendOrDownloadButton } from './SendOrDownloadButton';
const SendForm = styled.form `
  display: grid;
  grid-template-columns: 3.875rem 1fr 3rem;
  border-top: 1px solid #dedede;
`;
const SendFormMessageInput = styled(FormTextarea) `
  outline: none;
  box-shadow: none;
  resize: none;
  height: 3rem;
  align-self: center;
  overflow: hidden;
  background-color: white;
  caret-color: black;
  color: black;

  &:active:hover,
  &:focus {
    box-shadow: none;
  }
`;
export const ChatBoxFooter = ({ disableAttachmentButton = false, disableSendMessage = false, disabledDownloadButton = false, onSendMessage, onAddAttachmentClick, onDownloadTranscriptClick, }) => {
    var _a;
    const { t, i18n } = useTranslation();
    const [message, setMessage] = useState('');
    const handleSendMessage = useCallback(() => {
        if (message === '')
            return;
        setMessage('');
        onSendMessage === null || onSendMessage === void 0 ? void 0 : onSendMessage(message);
    }, [message, onSendMessage]);
    const handleKeyDown = useCallback(ev => {
        if (ev.shiftKey && ev.key === 'Enter') {
            return;
        }
        else if (ev.key === 'Enter') {
            ev.preventDefault();
            handleSendMessage();
        }
    }, [handleSendMessage]);
    const handleChange = useCallback((ev) => {
        setMessage(ev.target.value);
    }, []);
    return (React.createElement(SendForm, null,
        React.createElement(AddAttachmentButton, { onAddAttachmentClick: onAddAttachmentClick, disabled: disableAttachmentButton }),
        React.createElement(SendFormMessageInput, { "data-testid": "composer-form", disabled: disableSendMessage, onKeyDown: handleKeyDown, onChange: handleChange, value: message, rows: 1, placeholder: (_a = t('TYPE_YOUR_MESSAGE_TEXT')) !== null && _a !== void 0 ? _a : 'Type your message', dir: i18n.dir() }),
        React.createElement(SendOrDownloadButton, { state: message === '' ? 'download' : 'send', disabledDownloadButton: disabledDownloadButton, disabledSendMessageButton: disableSendMessage, onDownloadClick: onDownloadTranscriptClick, onSendClick: handleSendMessage })));
};
//# sourceMappingURL=ChatBoxFooter.js.map